// extracted by mini-css-extract-plugin
export default {"emptyBlock":"MainContainer_emptyBlock__wMSN1"};